import {
  useGetMeetingContextQuery,
  useGetMeetingParticipantsQuery,
} from 'src/app/zoomSdkQueries'
import { useGetHostSettingsQuery } from 'src/app/appApiQueries'

// this hook manages the host view current session data
// it waits for host settings to see if there is an activeSession present
// it fires sdk meeting queries at the same time
// it returns a combined loading state for the HostSession view
export const useGetHostContext = () => {
  const { isLoading: isHostSettingsLoading, data } =
    useGetHostSettingsQuery('hostSettings')
  // only fire these after the above is done loading
  const { isLoading: isMeetingContextLoading, data: contextData } =
    useGetMeetingContextQuery('getMeetingContext')
  const { isLoading: isParticipantsLoading, data: participantData } =
    useGetMeetingParticipantsQuery('getMeetingParticipants')

  return (
    // if we are loading anywhere
    isMeetingContextLoading ||
    isParticipantsLoading ||
    isHostSettingsLoading ||
    // and we don't yet have meeting data
    !contextData ||
    !participantData ||
    !data
  )
}
